import React, { forwardRef, ComponentProps } from 'react';

import Icon, { IconWithRender, generateRenderedIcon } from './Icon';
import { VIEWBOXES } from '../consts';
import { IconVariations } from '../useIconVariation';

const draw16px =
  'M12.64 8.35v5.2a1.21 1.21 0 0 1-.64 1.13 1.12 1.12 0 0 1-.47.11 1.28 1.28 0 0 1-.85-.33c-.2-.17-1.94-1.42-3.23-2.35-1.29.93-3 2.18-3.23 2.35a1.32 1.32 0 0 1-.85.33 1.16 1.16 0 0 1-.48-.11 1.21 1.21 0 0 1-.68-1.13V5.33A3.6 3.6 0 0 1 6.08 1.4h1.33a.75.75 0 0 1 0 1.5H6.08a2.11 2.11 0 0 0-2.41 2.43V13L7 10.58a.09.09 0 0 1 .07 0 .34.34 0 0 1 .12-.06.41.41 0 0 1 .19 0 .45.45 0 0 1 .2 0l.18.08c.53.37 2.36 1.68 3.25 2.34V8.35a.75.75 0 0 1 .76-.75.74.74 0 0 1 .87.75Zm1.09-5.71h-1.09V1.56a.74.74 0 0 0-.74-.75.75.75 0 0 0-.76.75v1.08h-1.08a.75.75 0 0 0 0 1.5h1.08v1.09a.76.76 0 0 0 .76.77.75.75 0 0 0 .74-.75V4.14h1.09a.75.75 0 1 0 0-1.5Z';
const draw24px =
  'M19.53,11.24v8.87a1.44,1.44,0,0,1-.81,1.37,1.24,1.24,0,0,1-.56.13,1.61,1.61,0,0,1-1-.41C16.8,20.92,14,18.93,12,17.48c-2,1.44-4.8,3.44-5.13,3.72a1.61,1.61,0,0,1-1,.41,1.24,1.24,0,0,1-.56-.13,1.44,1.44,0,0,1-.81-1.37V7.71c0-3.53,2-5.55,5.52-5.55h3.5a.75.75,0,0,1,0,1.5H10C7.33,3.66,6,5,6,7.71V20c.95-.74,4.85-3.51,5.53-4l.06,0a.61.61,0,0,1,.21-.11.57.57,0,0,1,.22,0h0a.57.57,0,0,1,.22,0,.71.71,0,0,1,.21.11l.06,0c.7.5,4.74,3.38,5.52,4V11.24a.75.75,0,0,1,1.5,0Zm2-7.21h-2V2A.75.75,0,0,0,18,2V4H16a.75.75,0,1,0,0,1.5h2v2a.75.75,0,0,0,1.5,0v-2h2a.75.75,0,0,0,0-1.5Z';

const icons: IconVariations = {
  _16: { d: draw16px, viewBox: VIEWBOXES._16 },
  _24: { d: draw24px, viewBox: VIEWBOXES._24 },
};

const BookmarkAddIcon = forwardRef<SVGSVGElement, ComponentProps<typeof Icon>>(
  generateRenderedIcon(icons, 'bookmarkAdd'),
) as IconWithRender;

BookmarkAddIcon.displayName = 'BookmarkAddIcon';
BookmarkAddIcon.propTypes = Icon.propTypes;
BookmarkAddIcon.renderIcon = (props) => <BookmarkAddIcon {...props} />;
export default BookmarkAddIcon;
